import { B, fonts, Btn, Badge } from "../../../components/UI";

// Reusable card row used by the Designs tab list.
export default function DesignRow({ design, onEdit, onToggle, onDelete, canDelete }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 14, padding: "12px 16px", background: design.active ? B.white : "#FFF8F5", border: `1px solid ${design.active ? B.borderLight : B.orangeMid}`, borderRadius: 12, marginBottom: 8, opacity: design.active ? 1 : 0.65 }}>
      <div style={{ width: 48, height: 58, background: B.orangeFaint, borderRadius: 8, overflow: "hidden", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
        {(design.imageUrl || design.images?.[0])
          ? <img src={design.imageUrl || design.images[0]} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          : <span style={{ fontSize: 22, opacity: 0.2 }}>👗</span>}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4, flexWrap: "wrap" }}>
          {design.badge && <Badge color={design.badge === "new" ? B.green : design.badge === "bestseller" ? B.gold : design.badge === "sale" ? B.red : B.orange}>{design.badge}</Badge>}
          {!design.active && <Badge color={B.red}>Out of Stock</Badge>}
          {design.fabric && <Badge color="#6A5ACD">🧵 {design.fabric}</Badge>}
          {design.images?.length > 1 && <Badge color="#2196F3">{design.images.length} photos</Badge>}
        </div>
        <div style={{ fontSize: 18, color: B.textLight, fontFamily: fonts.body }}>
          ₹ {design.price}
        </div>
        <div style={{ fontSize: 18, color: B.textLight, fontFamily: fonts.body }}>
          {design.design_number && <Badge color="#6A5ACD">Design Number: {design.design_number}</Badge>}
        </div>
      </div>
      <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
        <Btn onClick={() => onEdit(design)} variant="ghost" small>Edit</Btn>
        <Btn onClick={() => onToggle(design)} variant={design.active ? "danger" : "success"} small>{design.active ? "OOS" : "Restore"}</Btn>
        {canDelete && <Btn onClick={() => onDelete(design)} variant="danger" small>Del</Btn>}
      </div>
    </div>
  );
}
